import { SET_HEAD_INFO } from "../constants";

// Actions
export const setHeadInfo = (data) => ({
  type: SET_HEAD_INFO,
  payload: data,
});
